exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".browse-button {\n  width: 100%;\n  margin-top: 1em; }\n\n.run-button {\n  width: 25%;\n  margin-top: 2px;\n  background-color: gray; }\n\n.era-input-era {\n  display: none !important; }\n\n.excel-icon {\n  margin-left: 0.8em;\n  font-size: 20px;\n  color: #1464f6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/import-posting-batch/import-posting-batch.component.scss
// module id = 1978
// module chunks = 66